import React, {useEffect, useState} from 'react'
import cubejs from '@cubejs-client/core';
import WebSocketTransport from '@cubejs-client/ws-transport';
import { useCubeQuery } from '@cubejs-client/react';


const CUBE_TOKEN = localStorage.getItem('cubeToken')
const cubejsApi = cubejs({
  transport: new WebSocketTransport({
    authorization: CUBE_TOKEN,
    apiUrl: 'wss://testgcp-report-datalake.extramarks.com',
  }),
});


function CubeSocket() {

const query = {"measures":[],"order":{"CountryCityStateMapping.cityCode":"asc","CountryCityStateMapping.territoryCode":"asc"},"dimensions":["CountryCityStateMapping.cityCode","CountryCityStateMapping.territoryCode"],"limit":1000,"timezone":"UTC","timeDimensions":[],"filters":[],"renewQuery":false}


  const blendingQuery = [{"measures":["StudentAssessmentSummary.paperIdCount"],"order":{"StudentAssessmentSummary.paperIdCount":"desc"},"dimensions":[],"timezone":"UTC","timeDimensions":[{"dimension":"StudentAssessmentSummary.assignDate","dateRange":"Last Week","granularity":"week"}],"filters":[],"renewQuery":false},
  {"measures":["StudentAssessmentSummary.paperIdCount"],"order":{"StudentAssessmentSummary.paperIdCount":"desc"},"dimensions":[],"timezone":"UTC","timeDimensions":[{"dimension":"StudentAssessmentSummary.assignDate","dateRange":"This Week","granularity":"week"}],"filters":[],"renewQuery":false}]

  const { resultSet, error, isLoading } = useCubeQuery(query, { subscribe: true,cubejsApi });

  if (isLoading) {
     console.log("::LOADING::",isLoading)
  }
  if (error) {
     console.log("::ERROR::",error)
  }
  if(resultSet) {
  console.log("resultSet::",resultSet)
  }

  return (
    <div>CubeSocket</div>
  )
}

export default CubeSocket